import { render } from "./ApprovalComp.vue?vue&type=template&id=38b423c0"
import script from "./ApprovalComp.vue?vue&type=script&lang=js"
export * from "./ApprovalComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__